"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyTopRow = void 0;
var system_1 = require("@mui/system");
var BaseTableRow_1 = __importDefault(require("atomicComponents/atoms/Table/BaseTableRow"));
var StickyRow = (0, system_1.styled)(BaseTableRow_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'sticky',
        zIndex: 2,
        backgroundColor: theme.palette.common.white,
    });
});
exports.StickyTopRow = (0, system_1.styled)(StickyRow)(function () { return ({
    zIndex: 3,
}); });
exports.default = StickyRow;
